import React from "react";
import "./T2.css";

export default function T2({
  name,
  title,
  subtitle,
  subtitle_2,
  description,
  description_2,
  info,
  info_2,
  image_url,
  image_url_2,
  // novos campos de link
  link_url,
  link_url_2,
  link_tag,
  link_tag_2,
}) {
  const imageCount = [image_url, image_url_2].filter(Boolean).length;

  const links = [
    { url: link_url, tag: link_tag },
    { url: link_url_2, tag: link_tag_2 },
  ].filter((l) => !!l.url);

  return (
    <section className="t2-root">
      {/* decorações sutis */}
      <div className="t2-deco t2-deco--tl" />
      <div className="t2-deco t2-deco--br" />

      <div className="t2-container">
        {/* faixa de mídia no topo */}
        <div
          className={`t2-media-strip ${
            imageCount === 0 ? "is-none" : imageCount === 1 ? "is-one" : "is-two"
          }`}
          aria-label="galeria principal"
        >
          {image_url && (
            <figure className="t2-media">
              <img src={image_url} alt="" className="t2-img" />
            </figure>
          )}
          {image_url_2 && (
            <figure className="t2-media">
              <img src={image_url_2} alt="" className="t2-img" />
            </figure>
          )}
          {imageCount === 0 && <div className="t2-media-placeholder" />}
        </div>

        {/* conteúdo textual abaixo */}
        <div className="t2-text">
          {/* logo da marca (tem fundo vermelho e é retangular) */}
          <div className="t2-brand">
            <img src="/brand/brand-1.svg" alt="Sirrus" />
          </div>

          {name && <p className="t2-overline">{name}</p>}
          {title && <h1 className="t2-title">{title}</h1>}

          {subtitle && <p className="t2-subtitle">{subtitle}</p>}
          {subtitle_2 && <p className="t2-subtitle2">{subtitle_2}</p>}

          {description && <p className="t2-body">{description}</p>}
          {description_2 && <p className="t2-body">{description_2}</p>}

          {/* META ROW: links (primeiro) + infos (depois) no mesmo bloco */}
          {(links.length > 0 || info || info_2) && (
            <div className="t2-meta">
              {links.length > 0 && (
                <div className="t2-links">
                  {links.map((l, i) => (
                    <a
                      key={`link-${i}`}
                      className="t2-linkpill"
                      href={l.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={l.url}
                    >
                      <span className="t2-link-icon" aria-hidden>🔗</span>
                      <span>{l.tag?.trim() || l.url}</span>
                    </a>
                  ))}
                </div>
              )}

              {(info || info_2) && (
                <div className="t2-infos">
                  {info && <span className="t2-infopill">{info}</span>}
                  {info_2 && <span className="t2-infopill">{info_2}</span>}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
